import {asyncComponent} from '../components/HOC'

export const Accessibility = asyncComponent(() =>
  import('../pages/Accessibility' /* webpackChunkName: "accessibility-page" */),
)
export const AccountEvents = asyncComponent(() =>
  import('../pages/Account/Events' /* webpackChunkName: "account-events" */),
)
export const AccountInfo = asyncComponent(() =>
  import('../pages/Account/Info' /* webpackChunkName: "account-info" */),
)
export const AccountPasswordReset = asyncComponent(() =>
  import('../pages/Account/PasswordReset' /* webpackChunkName: "account-password-reset" */),
)
export const AddRemoveItems = asyncComponent(() =>
  import('../pages/AddRemoveItems' /* webpackChunkName: "add-remove-items" */),
)
export const AddressUpdate = asyncComponent(() =>
  import('../pages/AddressUpdate' /* webpackChunkName: "address-update" */),
)
export const AddressDetails = asyncComponent(() =>
  import('../pages/AddressDetails' /* webpackChunkName: "address-details" */),
)
export const BlackDesk = asyncComponent(() =>
  import('../pages/BlackDesk' /* webpackChunkName: "black-desk" */),
)
export const CancelAppointment = asyncComponent(() =>
  import(
    '../pages/CancelAppointment/CancelAppointment' /* webpackChunkName: "cancel-appointment" */
  ),
)
export const Careers = asyncComponent(() =>
  import('../pages/Careers' /* webpackChunkName: "careers" */),
)
export const Checkout = asyncComponent(() =>
  import('../pages/Checkout' /* webpackChunkName: "checkout" */),
)
export const DavidsBridal = asyncComponent(() =>
  import('../pages/DavidsBridal' /* webpackChunkName: "davids-bridal" */),
)
export const StyledLooks = asyncComponent(() =>
  import('../pages/StyledLooks' /* webpackChunkName: "styled-looks" */),
)
export const EventMgr = asyncComponent(() =>
  import('../pages/EventMgr' /* webpackChunkName: "event-mgr" */),
)
export const EventMgrOrder = asyncComponent(() =>
  import('../pages/EventMgrOrder' /* webpackChunkName: "event-mgr-order" */),
)
export const EventSummary = asyncComponent(() =>
  import('../pages/EventSummary' /* webpackChunkName: "event-summary" */),
)
export const FitGuarantee = asyncComponent(() =>
  import('../pages/FitGuarantee' /* webpackChunkName: "fit-guarantee" */),
)
export const FitLp = asyncComponent(() => import('../pages/FitLp' /* webpackChunkName: "fitlp" */))
export const FitPage = asyncComponent(() =>
  import('../pages/FitPage' /* webpackChunkName: "fitpage" */),
)
export const GarbageSuits = asyncComponent(() =>
  import('../pages/GarbageSuits' /* webpackChunkName: "garbage-suits" */),
)
export const Header = asyncComponent(() =>
  import('../components/Header/Header' /* webpackChunkName: "header" */),
)
export const Hp = asyncComponent(() => import('../pages/Homepage' /* webpackChunkName: "home" */))
export const Hiwp = asyncComponent(() => import('../pages/Hiwp' /* webpackChunkName: "hiwp" */))
export const HomeTryOn = asyncComponent(() =>
  import('../pages/HomeTryOn' /* webpackChunkName: "home-try-on" */),
)
export const Legal = asyncComponent(() =>
  import('../pages/Legal/Legal' /* webpackChunkName: "legal" */),
)
export const Logout = asyncComponent(() =>
  import('../pages/Logout' /* webpackChunkName: "logout" */),
)
export const LookbuilderMain = asyncComponent(() =>
  import('../pages/Lookbuilder/LookbuilderMain' /* webpackChunkName: "lookbuilder-main" */),
)
export const LostAndFound = asyncComponent(() =>
  import('../pages/LostAndFound' /* webpackChunkName: "lost-and-found" */),
)
export const Onboarding = asyncComponent(() =>
  import('../pages/Onboarding' /* webpackChunkName: "onboarding" */),
)
export const NotFound = asyncComponent(() =>
  import('../pages/NotFound' /* webpackChunkName: "not-found" */),
)
export const StaticPasswordReset = asyncComponent(() =>
  import(
    '../pages/PasswordForms/StaticPasswordReset' /* webpackChunkName: "static-password-reset" */
  ),
)
export const RentalAgreement = asyncComponent(() =>
  import('../pages/RentalAgreement/RentalAgreement' /* webpackChunkName: "rental-agreement" */),
)
export const RentalExtension = asyncComponent(() =>
  import('../pages/RentalExtension' /* webpackChunkName: "rental-extension" */),
)
export const RentToKeep = asyncComponent(() =>
  import('../pages/RentToKeep' /* webpackChunkName: "rent-to-keep" */),
)
export const RentToKeepTypeform = asyncComponent(() =>
  import('../pages/RentToKeepTypeform' /* webpackChunkName: "rent-to-keep-typeform" */),
)
export const RentToKeepPricing = asyncComponent(() =>
  import('../pages/RentToKeepPricing' /* webpackChunkName: "rent-to-keep-pricing" */),
)
export const Replacements = asyncComponent(() =>
  import('../pages/Replacements' /* webpackChunkName: "replacements" */),
)
export const Returns = asyncComponent(() =>
  import('../pages/Returns' /* webpackChunkName: "returns" */),
)
export const ReturnPolicy = asyncComponent(() =>
  import('../pages/ReturnPolicy' /* webpackChunkName: "return-policy" */),
)
export const OrderConfMain = asyncComponent(() =>
  import('../pages/PostCheckout/OrderConfMain' /* webpackChunkName: "order-conf-main" */),
)
export const OrderManager = asyncComponent(() =>
  import('../pages/OrderManager/OrderManager' /* webpackChunkName: "order-manager" */),
)
export const CartAddItem = asyncComponent(() =>
  import('../pages/OrderManager/Cart' /* webpackChunkName: "cart" */),
)
export const CheckoutAddItem = asyncComponent(() =>
  import('../pages/OrderManager/CheckoutAddItem' /* webpackChunkName: "order-manager" */),
)
export const CategoryPage = asyncComponent(() => import('../components/OrderManager/CategoryList'))

export const RemoveItemsPage = asyncComponent(() => import('../pages/OrderManager/remove-items'))

export const OurQuality = asyncComponent(() =>
  import('../pages/OurQuality' /* webpackChunkName: "our-quality" */),
)
export const OurStory = asyncComponent(() =>
  import('../pages/OurStory' /* webpackChunkName: "our-story" */),
)
export const ProductDetail = asyncComponent(() =>
  import('../components/Product/ProductDetailPage' /* webpackChunkName: "product-detail" */),
)
export const ProductMain = asyncComponent(() =>
  import('../components/Product/ProductMain' /* webpackChunkName: "product-main" */),
)
export const OldProductMain = asyncComponent(() =>
  import('../components/Product/OldProductMain' /* webpackChunkName: "old-product-main" */),
)
export const ProductReviews = asyncComponent(() =>
  import('../components/Product/Reviews/ProductReviews' /* webpackChunkName: "product-reviews" */),
)
export const Promp = asyncComponent(() => import('../pages/Promp' /* webpackChunkName: "promp" */))
export const RealWeddings = asyncComponent(() =>
  import('../pages/RealWeddings' /* webpackChunkName: "real-weddings" */),
)
export const Receipt = asyncComponent(() =>
  import('../pages/Receipt' /* webpackChunkName: "receipt" */),
)
export const ShowroomsMain = asyncComponent(() =>
  import('../pages/Showrooms' /* webpackChunkName: "" */),
)
export const SiteFooter = asyncComponent(() =>
  import('../components/SiteFooter/SiteFooter' /* webpackChunkName: "site-footer" */),
)
export const StaticLogin = asyncComponent(() =>
  import('../pages/Account/StaticLogin' /* webpackChunkName: "static-login" */),
)
export const StaticLoginRedirect = asyncComponent(() =>
  import('../pages/Account/StaticLoginRedirect' /* webpackChunkName: "static-login-redirect" */),
)
export const StaticRegistration = asyncComponent(() =>
  import('../pages/Account/StaticRegistration' /* webpackChunkName: "static-registration" */),
)
export const TuxedoSuitRental = asyncComponent(() =>
  import('../pages/TuxedoSuitRental' /* webpackChunkName: "tuxedo-suit-rental" */),
)
export const WeddingsLp = asyncComponent(() =>
  import('../pages/WeddingsLp' /* webpackChunkName: "wedding-tuxedos-suits" */),
)
export const FeatureFlags = asyncComponent(() =>
  import('../pages/FeatureFlags' /* webpackChunkName: "feature-flag-controller" */),
)
